import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DayDetail } from '@app/core/model/qualifications.model';

@Component({
  selector: 'app-days-panel',
  styleUrls: ['./days-panel.component.css'],
  templateUrl: './days-panel.component.html',
})
export class DaysPanelComponent implements OnInit {
  @Input() days: DayDetail[];
  @Output() selectedDay: EventEmitter<DayDetail> = new EventEmitter<DayDetail>();
  statusCanResponse = 'can respond';

  private allowedIcons = ['check', 'times'];

  constructor() {
    this.days = [];
  }

  clickDay(index: number) {
    if (this.days[index].status.toLowerCase() === this.statusCanResponse) {
      const selectedDay = this.days.find((day) => day.selected === true);
      let sameDay = false;

      if (selectedDay) {
        selectedDay.selected = false;
        sameDay = selectedDay.date === this.days[index].date;
      }

      this.days[index].selected = sameDay ? this.days[index].selected : true;
      this.selectedDay.emit(this.days[index]);
    }
  }

  ngOnInit() {
    const daysToRespond = this.days.filter(
      (day) => day.status.toLowerCase() === this.statusCanResponse
    );

    let latestDayToResond = null;
    if (daysToRespond.length > 0) {
      latestDayToResond = daysToRespond.reduce((a, b) => {
        return new Date(a.date) > new Date(b.date) ? a : b;
      });
    }

    let index = 0;
    this.days.forEach((day) => {
      day.selected = false;
      day.index = index;

      if (latestDayToResond !== null) {
        if (day.date === latestDayToResond.date) {
          day.selected = true;
          this.selectedDay.emit(day);
        }
      }

      this.setIconConfiguration(day);
      index++;
    });
  }

  updateDayStatusByResponse(day: DayDetail, response: string) {
    const indexDay = day.index;
    this.days[indexDay].status = response;

    if (response === 'Y') {
      this.days[indexDay].icon = 'check';
    } else if (response === 'N') {
      this.days[indexDay].icon = 'times';
    }

    this.setIconConfiguration(this.days[indexDay]);
    this.days[indexDay].disabled = true;

    return this.days[indexDay];
  }

  private setIconConfiguration(day: DayDetail) {
    if (this.allowedIcons.includes(day.icon)) {
      day.iconConfiguration = ['fas', day.icon];
    } else if (day.icon !== '') {
      console.warn(
        `StatPanelComponent: Icon '${day.icon}' is not part of the allowed icons.
         Allowed icons are: ${this.allowedIcons.toString()}`
      );
    }
  }
}
